import { GridSizedViewUtils } from "./GridSizeViewUtils";

import { CellRetrievalUtils } from "./CellRetrievalUtils";
import { ConnectorsUtils } from "./ConnectorsUtils";
import { SelectionWrapper } from "../modules/selection/SelectionWrapper";
import { ConnectingLineHandler } from "../modules/ConnectingLineHandler";
import { DIAGRAM_EMIT_EVENTS } from "../../../diagram/modules/DiagramEvents";
import { DiagramEventEmitter } from "../../../diagram/modules/DiagramEventEmitter";
import { getInstanceIDFromCanvasInstance } from "../../../diagram/diagram-assets/diagram-positioning-state";

/**
 * @description Handles the creation of a cell-dependent plugin through the drop event
 */
export class DroppedPluginCreator {
    /** @CellRetrievalUtils instance */
    cellRetrieval;

    /**
     * @ConnectorsUtils instnace
     */
    connectorsUtils;

    /**
     * @DiagramEventEmitter instance
     */
    eventEmitter;

    /**
     * the diagram instance id
     */
    instanceId;

    /**
     * @description Creates a dragged plugin dropped at a specific location
     * @param { Object } pos -  {x,y} object representing mouse position at the drop event
     * @param { Object } plugin - {plugin, id } id is the id of the plugin, plugin is the factory
     * @param { GridCell[][] } grid - Generated grid matrix holding all the GridCell References
     * @param { ConnectingLineHandler } lineHandler  - ConnectingLineHandler instance
     * @returns { Object }
     */
    createDroppedPlugin(pos, plugin, grid, lineHandler) {
        this.cellRetrieval = new CellRetrievalUtils();
        const gridSizeUtils = new GridSizedViewUtils();
        const cellPos = gridSizeUtils.getPermanentGridCellPos(pos, grid);
        const cell = this.cellRetrieval.getCell(cellPos, grid);
        this.instanceId = getInstanceIDFromCanvasInstance(cell.ctx);
        this.connectorsUtils = new ConnectorsUtils();
        this.eventEmitter = new DiagramEventEmitter(this.instanceId);

        if (!cell || (cell && (cell.hasContent() || cell.isVoid()))) {
            return null;
        }
        // this.eventEmitter.emitEvent(DIAGRAM_EMIT_EVENTS.PLUGIN_CREATED, { PLUGIN_ID: plugin.id }, true);
        cell.setNewPlugin(true);
        cell.update({}, { selected: true });
        cell.setContent({ factory: plugin.plugin }, { id: plugin.id });
        cell.draw();
        const selectionWrapper = new SelectionWrapper(this.instanceId);
        selectionWrapper.resetSpecific(["LINE", "CELL_INDEP"]);
        selectionWrapper.setSelected("CELL", cellPos, { event: false, grid });

        const connectingLineHandler = new ConnectingLineHandler(this.instanceId);
        connectingLineHandler.getClickedCellElement(cell.uuid, pos);

        this.connectorsUtils.performUpdatesOnConnector(grid, lineHandler, cell);
        cell.draw();
        return cellPos;
    }
}
